import { createTypes, async } from 'redux-action-creator'

const actionTypes = createTypes([
  ...async('LOAD_DATA_LAYER'),
  ...async('LOAD_GTM_SETTINGS')
], 'ANALYTICS')

export { actionTypes }
